import React, { useState } from 'react';
import useDrivePicker from 'react-google-drive-picker';

const GOOGLE_URL_FILES = "https://www.googleapis.com/drive/v3/files/{fileId}?alt=media";
export const PROVIDERS = {
  GDRIVE: "GOOGLE_DRIVE",
};
const EXTENSIONS = {
  GOOGLE_DRIVE: {
    PDF: "application/pdf",
    DOC: "application/msword",
    DOCX:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    XLS: "application/excel",
    XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    PPT: "application/mspowerpoint",
    PPTX:
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    JPG: "image/jpg",
    JPE: "image/jpe",
    JPEG: "image/jpeg",
    PNG: "image/png",
    BMP: "image/bmp",
    GIF: "image/gif",
    TIFF: "image/tiff",
    TIF: "image/tif",
    RTF: "image/rtf",
    CSV: "text/csv"
  }
};

export const getExtensions = (provider, extensions) => {
  const ext = [];
  if (extensions) {
    extensions.forEach(e => {
      if (EXTENSIONS[provider][e]) {
        ext.push(EXTENSIONS[provider][e]);
      } else {
        console.warn(`Extension NOT available '${e}' to: ${provider} provider`);
      }
    });
  }
  return ext;
};

export class Success {
  constructor(fileId, fileName, fileSize, urlDownload, providers, fileBlob) {
    this.fileId = fileId;
    this.fileName = fileName;
    this.fileSize = fileSize;
    if (urlDownload) {
      this.urlDownload = urlDownload;
    }
    this.provider = providers;
    if (fileBlob) {
      this.fileBlob = fileBlob;
    }
  }
}

function GoogleChooser(props){
  const [openPicker] = useDrivePicker();
  const { children } = props;
  // console.log(props)
  const getRequestFile = async (headers, doc) => {
    const { id: fileId, name: fileName, sizeBytes } = doc;

    // THE MAPPING BETWEEN THE PROVIDER'S
    // RESPONSE AND THE OBJECT OF SUCCESS
    const fileBlob = await fetch(
      GOOGLE_URL_FILES.replace("{fileId}", fileId),
      headers
    )
      .then(response => {
        if (response.ok) {
          return response.blob();
        }
        return null;
      })
      .then(dataBlob => {
        dataBlob.lastModifiedDate = new Date();
        dataBlob.name = fileName;
        const file = new Success(
          fileId,
          fileName,
          sizeBytes,
          null,
          PROVIDERS.GDRIVE,
          dataBlob
        );
        return file;
      })
      .catch(error => {
        console.error(error);
      });

    return fileBlob;
  };

  const handleOpenPicker = () => {
    gapi.load('client:auth2', () => {
      gapi.client
        .init({
          apiKey: props.developerKey,
        })
        .then(() => {
          let tokenInfo = gapi.auth.getToken();
          const pickerConfig = {
            clientId: props.clientId,
            developerKey: props.developerKey,
            viewId: 'DOCS',
            viewMimeTypes: 'application/pdf',
            token: tokenInfo ? tokenInfo.access_token : null,
            showUploadView: false,
            showUploadFolders: false,
            supportDrives: true,
            multiselect: props.multiselect,
            callbackFunction: (data) => {
              const { success } = props;
              if (data.action === 'picked') {
                const promiseList = [];
                //Add your desired workflow when choosing a file from the Google Picker popup
                //In this below code, I'm attempting to get the file's information.
                if (!tokenInfo) {
                  tokenInfo = gapi.auth.getToken();
                }
                const fetchOptions = {
                  headers: {
                    Authorization: `Bearer ${tokenInfo.access_token}`,
                  },
                };
                data.docs.map(async (item) => {
                  promiseList.push(getRequestFile(fetchOptions, item));
                });
                Promise.all(promiseList)
                .then(files => {
                  if (success) {
                    success(files);
                  }
                })
                .catch(err => {
                  console.error(err);
                });
              }
            },
          };
          openPicker(pickerConfig);
        });
    });
  };

  return (
    <div onClick={handleOpenPicker}>
      {children || <div>Open google chooser</div>}
    </div>
  );
};

export default GoogleChooser;